export const CACHE_TIMEOUT_DURATION = 0.000001;
export const ENERGY_FLOW_WIDGET_POLLING_INTERVAL_IN_MS = 10000;
export const DEFAULT_LANGUAGE = 'en-US';
